import dynamic from "next/dynamic"

// TinyMCE does not support SSR. Importing it directly will cause an error stating, "navigator is not defined"
const RichTextInputWithNoSSR: any = dynamic(
    () => import("./RichTextInputDisplay"),
    { ssr: false }
)

export default RichTextInputWithNoSSR
